export const enhanceAddCheckoutText = (root) => {
	const summary = root.querySelector('.wp-block-woocommerce-checkout-order-summary-block')
	if (!summary) return
	if (root.querySelector('.my-checkout-note')) return

	const note = document.createElement('div')
	note.className = 'my-checkout-note'
	note.innerHTML = `` // Eventually we'll add some card / payment methods here
	summary.insertAdjacentElement('afterend', note)
}
